module.exports = __webpack_public_path__ + "static/img/zhhq-jdglpt-01.86ca5c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq-jdglpt-01.png
// module id = QPeP
// module chunks = 1